import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ShadowPropTypesIOS } from 'react-native';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';
import TextInputContainer from './TextInputContainer';
import * as rtApi from './Api';
import { AntDesign } from '@expo/vector-icons';
import * as Location from 'expo-location';
import UserState from '../src/contexts/UserState';

const AddressPicker = ({ ...props }) => {
  const [user, setUser] = React.useContext(UserState);

  const [addressSuggestions, setAddressSuggestions] = React.useState([]);
  const [addressLoading, setAddressLoading] = React.useState(false);
  const [showAddressSuggestionOverlay, setShowAddressSuggestionOverlay] = React.useState(false);
  const [location, setLocation] = React.useState(null);
  const [addressIsSet, setAddressIsSet] = React.useState(props.isSet || false);

  // const ac = new AbortController();

  // React.useEffect(() => {
  //   return () => ac.abort();
  // }, []);

  // React.useEffect(() => {
  //   console.log('useEffect on props.address')
  //   if (props.address) {
  //     setAddressIsSet(true);
  //   }
  // }, [props.address])

  React.useEffect(() => {
    console.log('useEffect on address picker: ', props.value);
    if (props.value) {
      setAddressIsSet(true);
    }
  }, []);

  React.useEffect(() => {
    if (props.isSet) {
      setAddressIsSet(true);
    }
  }, [props.isSet]);

  const addressChange = (a) => {
    console.log('addressChange', a);
    props.setAddress(a);
    if (a && a.trim().length < 3) { return; }
    let l = '';
    if (location) {
      l = '&longitude=' + location.coords.longitude + '&latitude=' + location.coords.latitude;
    }
    setAddressLoading(true);
    rtApi.cancel();
    rtApi.get('search/street?term=' + a + l)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('data', data);
      if (data.error) { throw (data.error); }
      setAddressSuggestions(data.search_results);
      setAddressLoading(false);
    })
    .catch((error) => {
      console.log('addressPicker addressChange err: ', error);
      setAddressLoading(false);
      setAddressSuggestions([]);
    });
    // fetch(api.base + 'search/street?term=' + a + l, { signal: ac.signal })
    //   .then(res => res.json())
    //   .then(data => {
    //     console.log('data', data);
    //     if (data.error) { throw (data.error); }
    //     setAddressSuggestions(data.search_results);
    //     setAddressLoading(false);
    //   })
    //   .catch((error) => {
    //     console.log('addressPicker addressChange err: ',error);
    //     setAddressLoading(false);
    //     setAddressSuggestions([]);
    //   });
  };
  const getLocation = async () => {
    let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
      console.log('Permission to access location was denied');
    } else {
      //faster but may not be accurate
      let loc1 = await Location.getLastKnownPositionAsync({});
      setLocation(loc1);
      console.log('loc1', loc);
      // slower but accurate
      let loc = await Location.getCurrentPositionAsync({});
      console.log('loc', loc);
      setLocation(loc);
    }
  }
  const toggleAddressSuggestionOverlay = async () => {
    console.log('toggleAddressSuggestionOverlay', addressIsSet);
    if(addressIsSet){ return; }
    getLocation();
    setShowAddressSuggestionOverlay(prevState => {
      if (!prevState) {
        // open
        props.setAddress('');
        if(props.setStreetId){
          props.setStreetId(null);
        }
        if (props.setScrollEnabled) { props.setScrollEnabled(false); }
      } else {
        afterClose();
        // close
        console.log(props.inputRef);
        // props.inputRef.blur();
        blurInput();
      }
      return !prevState;
    });
  };
  const selectAddress = (address) => {
    console.log('selectAddress', address);
    props.setAddress(address.full_address);
    // conditional, maybe all will require this at some point .. ?
    if (props.setStreetId) {
      props.setStreetId(address.id);
    }
    if (props.setZipCode) {
      props.setZipCode(address.zip_code);
    }
    if (props.setStreetNumber) {
      props.setStreetNumber(address.street_number);
    }
    if (props.setCountry) {
      props.setCountry(String(address.zip_code).length === 5 ? 'United States' : 'Canada');
    }
    if (location) {
      if (props.setLongitude) {
        props.setLongitude(location.coords.longitude);
      }
      if (props.setLatitude) {
        props.setLatitude(location.coords.latitude);
      }
    }
    if (props.setAddressUnit) {
      props.setAddressUnit(address.unit);
    };
    setAddressSuggestions([]);
    setShowAddressSuggestionOverlay(false);
    setAddressIsSet(true);
    if (props.setIsInvalid && typeof props.setIsInvalid === 'function') {
      props.setIsInvalid();
    }
    if (props.setAddressDeleted && typeof props.setAddressDeleted === 'function'){
      props.setAddressDeleted(false);
    }
    afterClose();
  };

  const afterClose = () => {
    if (props.afterSelectLocation && typeof props.afterSelectLocation === 'function') {
      props.afterSelectLocation();
    }
  }

  const calcOffsetHeight = () => {
    return {
      paddingTop: props.offsetTop ? props.offsetTop : 0,
    }
  }

  const removeAddress = () => {
    console.log('removeAddress()');
    setAddressIsSet(false);
    props.setAddress('');
    if(props.setStreetId){
      props.setStreetId(null);
    }
    if (props.setZipCode) {
      props.setZipCode(null);
    }
    if (props.setStreetNumber) {
      props.setStreetNumber(null);
    }
    if (props.setCountry) {
      props.setCountry(null);
    }
    if (props.setAddressUnit) {
      props.setAddressUnit(null);
    };
    if (props.setAddressDeleted && typeof props.setAddressDeleted === 'function') {
      props.setAddressDeleted(true);
    }
    props.inputRef.current.focus();
  }

  const blurInput = () => {
    setAddressIsSet(true);
    setTimeout(() => {
      setAddressIsSet(false);
    }, 0);
  }

  return (
    <View style={[styles.outerContainer, props.outerInputContainerStyle]}>
      <TextInputContainer
        iconName={props.iconName ? props.iconName : null}
        placeholder={props.innerPlaceholder || '10-1000 Main St. Toronto, ON'}
        onFocus={() => toggleAddressSuggestionOverlay()}
        // onPress={() => toggleAddressSuggestionOverlay()}
        onChangeText={(t) => addressChange(t)}
        value={props.value}
        inputRef={props.inputRef}
        isInvalid={props.isInvalid}
        // textContentType='fullStreetAddress'
        // autoCompleteType='street-address'
        textContentType='none'
        autoCompleteType='off'
        returnKeyType='done'
        spellCheck={false}
        autoCorrect={false}
        editable={!addressIsSet}
        disabledStyling={false}
        inputContainerStyle={{ marginBottom: 0 }}
      />
      {addressIsSet &&
        <TouchableOpacity style={styles.removeAddress} onPress={() => removeAddress()} activeOpacity='0.7'>
          <AntDesign name="closecircleo" size={24} color={Colors.white} style={{ position: 'absolute' }} />
          <AntDesign name="closecircle" size={24} color={Colors.lightBlue2} />
        </TouchableOpacity>
      }
      {addressSuggestions.length >= 1 &&
        <View style={styles.addressSuggestions}>
          {addressSuggestions.map((a, i) => (
            <TouchableOpacity onPress={() => selectAddress(a)} key={i} style={[styles.addressSuggestion, (i + 1 === addressSuggestions.length) ? styles.addressSuggestionNoBorder : styles.addressSuggestionBorder]}>
              <Text style={[CS.lightText, CS.smallText]}>{a.full_address}</Text>
            </TouchableOpacity>
          ))}
        </View>
      }
    </View>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    marginBottom: 20,
    zIndex:100,
  },
  suggestionsCloseButton: {
    marginBottom: 10,
  },
  addressSuggestions: {
    position: 'absolute',
    top: 43,
    left: 0,
    width: '100%',
    zIndex: 1000,
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 10,
    // paddingBottom: 10,
    backgroundColor: Colors.textInputBackground,
  },
  addressSuggestion: {
    padding: 10,
    borderColor: Colors.lightBlue,
  },
  addressSuggestionBorder: {
    borderBottomWidth: 1,
  },
  addressSuggestionNoBorder: {
    borderBottomWidth: 0,
  },
  removeAddress: {
    position: 'absolute',
    // top:8,
    // right: 8,
    top: 0,
    right: 0,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    // backgroundColor: 'red'
  }
});

export default AddressPicker;